import { DprOnlineApproveModalComponent } from './dpr-online-approve-modal/dpr-online-approve-modal.component';
import { DigitalSignatureModalComponent } from './digital-signature-modal/digital-signature-modal.component';
import { DprApproverComponent } from './dpr-approver/dpr-approver.component';
import { DprCardApproversComponent } from './dpr-card-approvers/dpr-card-approvers.component';
import { DprCardDetailsComponent } from './dpr-card-details/dpr-card-details.component';
import { DprListComponent } from './dpr-list/dpr-list.component';
import { ReportHistoryModalComponent } from './report-history-modal/report-history-modal.component';
import { DownloadDprModalComponent } from './download-dpr-modal/download-dpr-modal.component';
import { SetupDprDateModalComponent } from './setup-dpr-date-modal/setup-dpr-date-modal.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DprStatusFilterComponent } from './dpr-status-filter/dpr-status-filter.component';

export {
  DprCardDetailsComponent,
  DigitalSignatureModalComponent,
  ReportHistoryModalComponent,
  DprCardApproversComponent,
  DprApproverComponent,
  DprListComponent,
  DprOnlineApproveModalComponent,
  DownloadDprModalComponent,
  SetupDprDateModalComponent,
  DateRangePickerComponent,
  DprStatusFilterComponent,
};

export const components = [
  DprCardDetailsComponent,
  DigitalSignatureModalComponent,
  DprCardApproversComponent,
  DprApproverComponent,
  ReportHistoryModalComponent,
  DprListComponent,
  DprOnlineApproveModalComponent,
  DownloadDprModalComponent,
  SetupDprDateModalComponent,
  DateRangePickerComponent,
  DprStatusFilterComponent,
];
